import SuccessView from "../../../common/success";
import { Amount } from "../../../../../amount/amount";
import { isPlainObject, getValueAtPath, objectWithAccessors } from "../../../../../utils";

export default function __onChargeSuccessful__() {
  const $this = this;

  return function onChargeSuccessful() {
    if (isPlainObject(this)) {
      const { data, reference } = this;
      const paymentMethod = getValueAtPath($this.STATE, 'method.current');

      $this.$$data = data;
      $this.reference = reference;

      switch (paymentMethod) {
        case '1voucher': {
          const changeVoucher = getValueAtPath(data, 'meta_data.change_voucher');

          if (isPlainObject(changeVoucher)) {
            const { amount, pin, serial, expiry } = changeVoucher;

            if (amount && pin && serial && expiry) {
              const chargeAmount = new Amount(amount, 'ZAR');

              $this.CHANGE_VOUCHER = objectWithAccessors({
                amount: () => chargeAmount,
                pin: () => pin,
                serial: () => serial,
                expiry: () => expiry
              });

              break;
            }
          }

          $this.CHANGE_VOUCHER = false;
          break;
        }

        default: {
          SuccessView && SuccessView.activate.call($this);
        }
      }
    }
  }
}
